const COPIED: readonly string[] = [
  "font-family",
  "font-size",
  "font-weight",
  "font-style",
  "font-variant",
  "letter-spacing",
  "line-height",
  "text-align",
  "text-indent",
  "text-transform",
  "word-spacing",
  "tab-size",
  "overflow-wrap",
  "word-break",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left",
];

// Pixel position of the character at `index` within a textarea, relative to the
// textarea's border-box origin (before scroll). Renders an off-screen mirror
// that wraps text identically, then reads where the remaining text begins.
export function caretCoordinates(
  textarea: HTMLTextAreaElement,
  index: number
): { left: number; top: number; height: number } {
  const cs = getComputedStyle(textarea);
  const mirror = document.createElement("div");
  const style = mirror.style;
  for (const property of COPIED) {
    style.setProperty(property, cs.getPropertyValue(property));
  }
  style.position = "absolute";
  style.visibility = "hidden";
  style.top = "0";
  style.left = "-9999px";
  style.boxSizing = "border-box";
  style.border = "0";
  style.whiteSpace = "pre-wrap";
  style.overflow = "hidden";
  style.width = `${textarea.clientWidth}px`;
  style.height = "auto";

  mirror.textContent = textarea.value.slice(0, index);
  const marker = document.createElement("span");
  // A non-empty marker guarantees a measurable box even at the end of the text.
  marker.textContent = textarea.value.slice(index) || ".";
  mirror.appendChild(marker);
  document.body.appendChild(mirror);

  const borderLeft = parseFloat(cs.borderLeftWidth) || 0;
  const borderTop = parseFloat(cs.borderTopWidth) || 0;
  let lineHeight = parseFloat(cs.lineHeight);
  if (Number.isNaN(lineHeight)) lineHeight = parseFloat(cs.fontSize) * 1.2;
  const result = {
    left: marker.offsetLeft + borderLeft,
    top: marker.offsetTop + borderTop,
    height: lineHeight,
  };
  document.body.removeChild(mirror);
  return result;
}
